import {
 ADDCART,
 ADDPRODUCT,
 PRODQUETYDECREMENT,
 PRODQUETYINCREMENT,
} from "./actionTypes";

export const addProduct = (prodDetails) => {
 return {
  type: ADDPRODUCT,
  payload: prodDetails,
 };
};
export const addCard = (prodDetails) => {
 return {
  type: ADDCART,
  payload: prodDetails,
 };
};

export const prodQuetyIncrement = (id, value) => {
 return {
  type: PRODQUETYINCREMENT,
  payload: {
   id,
   increment: value,
  },
 };
};
export const prodQuetyDecrement = (id) => {
 return {
  type: PRODQUETYDECREMENT,
  payload: {
   id,
   decrement: 1,
  },
 };
};
